import script from "./finance.vue?vue&type=script&setup=true&lang=js"
export * from "./finance.vue?vue&type=script&setup=true&lang=js"

import "./finance.vue?vue&type=style&index=0&id=83bc2fb0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83bc2fb0"]])

export default __exports__